import { useState } from "react";
import { FEATURE_FLAGS, HubUserMeResponse } from "@cede/types";
import { CEDE_CEXS } from "@cede/utils";
import { useHubUser } from "./useHubUser";
import { useFeatureFlagIsOn } from "@/hooks/feature-flags";
import { FLOW_TYPES, useConnectStore } from "@/store/connectStore";
import { useAutoRemoveExchangeAccountStore } from "@/store/useAutoRemoveExchangeAccountStore";

export const useAutoRemoveExchangeAccountForSecurityReason = () => {
  const { hubUser, removeExchangeAccount } = useHubUser();
  const [previousMe, setPreviousMe] = useState<HubUserMeResponse | null>(null);
  const { setExchangeAccountToRemove, setOpen } = useAutoRemoveExchangeAccountStore();
  const { setFlowType } = useConnectStore();
  const shouldAutoRemoveExchangeAccountForSecurityReason = useFeatureFlagIsOn(
    FEATURE_FLAGS.AUTO_REMOVE_EXCHANGE_ACCOUNT_FOR_SECURITY_REASON,
  );

  if (hubUser && previousMe !== hubUser && shouldAutoRemoveExchangeAccountForSecurityReason) {
    setPreviousMe(hubUser);

    const gateioExchangeAccount = hubUser.exchangeAccounts.find((exchange) => exchange.exchangeId === CEDE_CEXS.GATEIO);
    if (gateioExchangeAccount && !gateioExchangeAccount.stpGroupId) {
      // remove the exchange account
      setExchangeAccountToRemove(gateioExchangeAccount);
      setOpen(true);
      setFlowType(FLOW_TYPES.RELINK);
      removeExchangeAccount({
        accountId: gateioExchangeAccount.id.toString(),
        exchangeId: gateioExchangeAccount.exchangeId,
      });
    }
  }
};
